import {ValidationResult} from "@/shared/timr";
import {ValidationSeverity} from "@/shared/timrTypes";

/**
 * Returns transmitted validation result list by severity (CRITICAL -> MAJOR -> MINOR -> INFO)
 * If severity is equal it's sorted by message of validation
 * @param validations list of validation results to sort
 */
export function sortBySeverity(validations: ValidationResult[]) {
	return validations
		.sort((a, b) => {
			// if severities are different, sort by severity first
			const aSeverity = Object.keys(ValidationSeverity).indexOf(b.severity),
				bSeverity = Object.keys(ValidationSeverity).indexOf(a.severity);
			if (aSeverity !== bSeverity) {
				return aSeverity > bSeverity ? 1 : -1;
			}

			// if messages are different, sort by message afterward
			const messageCompare = messages.withArguments(a.messageCode, ...a.messageArguments).localeCompare(messages.withArguments(b.messageCode, ...b.messageArguments));
			if (messageCompare !== 0) {
				return messageCompare;
			}

			// then sort by id, just to ensure sorting is always in the same order for multiple iterations
			return a.id > b.id ? 1 : -1;
		});
}

/**
 * Returns highest severity in validation results list
 * @param validationResults list of validation results
 */
export function getHighestSeverity(validationResults: ValidationResult[]): ValidationSeverity {
	// create array of validation enum index (ordinal)
	const arr = validationResults.map(v => Object.keys(ValidationSeverity).indexOf(v.severity));

	// find the highest severity index by the highest index
	const highestSeverity = validationResults ? Math.max(...arr) : null;

	// return enum with index
	return Object.keys(ValidationSeverity)[highestSeverity] as ValidationSeverity;
}
